import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reg-contact-support',
  templateUrl: './account-reg-contact-support.component.html',
  styleUrls: ['./account-reg-contact-support.component.scss']
})
export class AccountRegistrationContactTechSupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
